import React, { useState } from 'react';
import { Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/Layout';
import LoginForm from './components/LoginForm';
import './custom.css';
import CookieManager from './CookieManager';

const App = () => {

  const [loginErrorMessage, setLoginErrorMessage] = useState('');

  const location = useLocation();
  const navigate = useNavigate();


  // login reale JWT
  const handleLogin = async (username, password) => {

    try {

      const response = await fetch('auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });

      if (response.ok) {

        setLoginErrorMessage('');

        const data = await response.json();

        CookieManager.set(data);

        const { from } = location.state || { from: { pathname: '/' } };

        navigate(from);

      }
      else {

        setLoginErrorMessage(response.status + ' - ' + response.statusText);

      }

    } catch (error) {

      console.error(error);

    }

  };


  const handleLogout = () => {

    CookieManager.remove();

    navigate('/login');

  };


  return (

    <Layout
      isLoggedIn={CookieManager.isValid()}
      handleLogout={handleLogout}
    >

      <Routes>

        {AppRoutes.map((route, index) => {

          const { element, path, isPrivate } = route;

          return (
            <Route
              key={index}
              path={path}
              element={
                isPrivate
                  ? <PrivateRoute>{element}</PrivateRoute>
                  : element
              }
            />
          );

        })}

        <Route
          path="/login"
          element={
            <LoginForm
              errorMessage={loginErrorMessage}
              handleLogin={handleLogin}
            />
          }
        />

        <Route path="/logout" element={<Navigate to="/login" />} />

      </Routes>

    </Layout>

  );

};

/*
  NOTE:
  > In React Router v6 NON si wrappa pi� <Route>:

    const PrivateRoute = ({ element, ...rest }) => {
      const isLoggedIn = CookieManager.get();
      return isLoggedIn ? <Route {...rest} element={element} /> : <Navigate to="/login" />;
    };

  si wrappa l'element:
*/

const PrivateRoute = ({ children }) => {

  return CookieManager.isValid()
    ? children
    : <Navigate to="/login" replace />;

};

export default App;
